<template>
  <div class="px-40 py-10 feedback" id="feedback">
    <div class="flex justify-between">
      <div class="flex items-center justify-start align-start">
        <div class="w-48 h-1 bg-white rounded-sm"></div>
        <h1 class="px-8 py-8 text-xl font-bold">
          Avis de Nos <span class="primary">Clients</span>
        </h1>
      </div>
      <div class="flex items-center gap-4 align-center">
        <div class="w-48 h-1 bg-white rounded-sm"></div>
        <div class="w-5 h-5 bg-white rounded-full"></div>
        <div class="w-5 h-5 bg-white rounded-full"></div>
        <div class="w-5 h-5 rounded-full bg-primary"></div>
        <div class="w-5 h-5 bg-white rounded-full"></div>
        <div class="w-5 h-5 bg-white rounded-full"></div>
      </div>
    </div>
    <div class="flex flex-col items-start align-start">
      <h1 class="py-2 text-5xl font-bold text-white">
        Ce que nos <span class="text-5xl primary">Utilisateurs </span>
      </h1>
      <h1 class="py-2 text-5xl font-bold">Disent de Nous</h1>
    </div>

    <!-- <div class="flex justify-between">
      <div class="w-24 h-24 rounded-full bg-primary"></div>
      <div class="w-24 h-24 rounded-full bg-primary"></div>
      <div class="w-24 h-24 rounded-full bg-primary"></div>
    </div> -->
    <div class="flex gap-10 py-24">
      <div
        class="relative flex flex-col items-center justify-center w-1/3 p-5 bg-white rounded-lg align-center"
      >
        <div
          class="text-7xl absolute w-28 h-28 border-solid border-4 border-white rounded-full bg-primary top-[-50px] right-0 left-0 ml-auto mr-auto flex items-center justify-center align-center"
        >
          “
        </div>
        <h1 class="pb-4 text-3xl font-bold text-black pt-14">Bonkey</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="147"
          height="22"
          viewBox="0 0 147 22"
          fill="none"
        >
          <path
            d="M11.4455 0.144043L14.2444 6.8734L21.5093 7.45583L15.9742 12.1972L17.6653 19.2865L11.4455 15.4875L5.22571 19.2865L6.91677 12.1972L1.38168 7.45583L8.64658 6.8734L11.4455 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M42.6867 0.144043L45.4856 6.8734L52.7505 7.45583L47.2154 12.1972L48.9065 19.2865L42.6867 15.4875L36.4669 19.2865L38.158 12.1972L32.6229 7.45583L39.8878 6.8734L42.6867 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M73.9279 0.144043L76.7268 6.8734L83.9917 7.45583L78.4566 12.1972L80.1477 19.2865L73.9279 15.4875L67.7081 19.2865L69.3992 12.1972L63.8641 7.45583L71.129 6.8734L73.9279 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M105.169 0.144043L107.968 6.8734L115.233 7.45583L109.698 12.1972L111.389 19.2865L105.169 15.4875L98.9495 19.2865L100.641 12.1972L95.1054 7.45583L102.37 6.8734L105.169 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M136.41 0.144043L139.209 6.8734L146.474 7.45583L140.939 12.1972L142.63 19.2865L136.41 15.4875L130.191 19.2865L131.882 12.1972L126.347 7.45583L133.612 6.8734L136.41 0.144043Z"
            fill="#FF3839"
          />
        </svg>
        <p class="text-[#696969] text-lg py-3">
          Service exceptionnel : L'équipe de Smart Coders Pro a surpassé nos
          attentes ! Leur professionnalisme et leur capacité à comprendre nos
          besoins ont été remarquables. Nos projets digitaux ont été livrés dans
          les délais et avec une qualité impeccable.
        </p>
      </div>
      <div
        class="relative flex flex-col items-center justify-center w-1/3 p-5 bg-white rounded-lg align-center"
      >
        <div
          class="text-7xl absolute w-28 h-28 border-solid border-4 border-white rounded-full bg-primary top-[-50px] right-0 left-0 ml-auto mr-auto flex items-center justify-center align-center"
        >
          “
        </div>
        <h1 class="pb-4 text-3xl font-bold text-black pt-14">Ayétché</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="147"
          height="22"
          viewBox="0 0 147 22"
          fill="none"
        >
          <path
            d="M11.4455 0.144043L14.2444 6.8734L21.5093 7.45583L15.9742 12.1972L17.6653 19.2865L11.4455 15.4875L5.22571 19.2865L6.91677 12.1972L1.38168 7.45583L8.64658 6.8734L11.4455 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M42.6867 0.144043L45.4856 6.8734L52.7505 7.45583L47.2154 12.1972L48.9065 19.2865L42.6867 15.4875L36.4669 19.2865L38.158 12.1972L32.6229 7.45583L39.8878 6.8734L42.6867 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M73.9279 0.144043L76.7268 6.8734L83.9917 7.45583L78.4566 12.1972L80.1477 19.2865L73.9279 15.4875L67.7081 19.2865L69.3992 12.1972L63.8641 7.45583L71.129 6.8734L73.9279 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M105.169 0.144043L107.968 6.8734L115.233 7.45583L109.698 12.1972L111.389 19.2865L105.169 15.4875L98.9495 19.2865L100.641 12.1972L95.1054 7.45583L102.37 6.8734L105.169 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M136.41 0.144043L139.209 6.8734L146.474 7.45583L140.939 12.1972L142.63 19.2865L136.41 15.4875L130.191 19.2865L131.882 12.1972L126.347 7.45583L133.612 6.8734L136.41 0.144043Z"
            fill="#FF3839"
          />
        </svg>
        <p class="text-[#696969] text-lg py-3">
          Collaboration agréable : Travailler avec Smart Coders Pro a été une
          expérience très collaborative. Ils écoutent vraiment les feedbacks et
          intègrent rapidement nos suggestions, ce qui rend le processus très
          fluide et agréable.
        </p>
      </div>
      <div
        class="relative flex flex-col items-center justify-center w-1/3 p-5 bg-white rounded-lg align-center"
      >
        <div
          class="text-7xl absolute w-28 h-28 border-solid border-4 border-white rounded-full bg-primary top-[-50px] right-0 left-0 ml-auto mr-auto flex items-center justify-center align-center"
        >
          “
        </div>
        <h1 class="pb-4 text-3xl font-bold text-black pt-14">Felix</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="147"
          height="22"
          viewBox="0 0 147 22"
          fill="none"
        >
          <path
            d="M11.4455 0.144043L14.2444 6.8734L21.5093 7.45583L15.9742 12.1972L17.6653 19.2865L11.4455 15.4875L5.22571 19.2865L6.91677 12.1972L1.38168 7.45583L8.64658 6.8734L11.4455 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M42.6867 0.144043L45.4856 6.8734L52.7505 7.45583L47.2154 12.1972L48.9065 19.2865L42.6867 15.4875L36.4669 19.2865L38.158 12.1972L32.6229 7.45583L39.8878 6.8734L42.6867 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M73.9279 0.144043L76.7268 6.8734L83.9917 7.45583L78.4566 12.1972L80.1477 19.2865L73.9279 15.4875L67.7081 19.2865L69.3992 12.1972L63.8641 7.45583L71.129 6.8734L73.9279 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M105.169 0.144043L107.968 6.8734L115.233 7.45583L109.698 12.1972L111.389 19.2865L105.169 15.4875L98.9495 19.2865L100.641 12.1972L95.1054 7.45583L102.37 6.8734L105.169 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M136.41 0.144043L139.209 6.8734L146.474 7.45583L140.939 12.1972L142.63 19.2865L136.41 15.4875L130.191 19.2865L131.882 12.1972L126.347 7.45583L133.612 6.8734L136.41 0.144043Z"
            fill="#FF3839"
          />
        </svg>
        <p class="text-[#696969] text-lg py-3">
          Créativité inspirante : Nous avons été impressionnés par la créativité
          de Smart Coders Pro. Leurs idées innovantes et leur sens du design ont
          vraiment donné vie à notre vision. C'est un plaisir de travailler avec
          eux.
        </p>
      </div>
      <div
        class="relative flex flex-col items-center justify-center w-1/3 p-5 bg-white rounded-lg align-center"
      >
        <div
          class="text-7xl absolute w-28 h-28 border-solid border-4 border-white rounded-full bg-primary top-[-50px] right-0 left-0 ml-auto mr-auto flex items-center justify-center align-center"
        >
          “
        </div>
        <h1 class="pb-4 text-3xl font-bold text-black pt-14">Cherif</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="147"
          height="22"
          viewBox="0 0 147 22"
          fill="none"
        >
          <path
            d="M11.4455 0.144043L14.2444 6.8734L21.5093 7.45583L15.9742 12.1972L17.6653 19.2865L11.4455 15.4875L5.22571 19.2865L6.91677 12.1972L1.38168 7.45583L8.64658 6.8734L11.4455 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M42.6867 0.144043L45.4856 6.8734L52.7505 7.45583L47.2154 12.1972L48.9065 19.2865L42.6867 15.4875L36.4669 19.2865L38.158 12.1972L32.6229 7.45583L39.8878 6.8734L42.6867 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M73.9279 0.144043L76.7268 6.8734L83.9917 7.45583L78.4566 12.1972L80.1477 19.2865L73.9279 15.4875L67.7081 19.2865L69.3992 12.1972L63.8641 7.45583L71.129 6.8734L73.9279 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M105.169 0.144043L107.968 6.8734L115.233 7.45583L109.698 12.1972L111.389 19.2865L105.169 15.4875L98.9495 19.2865L100.641 12.1972L95.1054 7.45583L102.37 6.8734L105.169 0.144043Z"
            fill="#FF3839"
          />
          <path
            d="M136.41 0.144043L139.209 6.8734L146.474 7.45583L140.939 12.1972L142.63 19.2865L136.41 15.4875L130.191 19.2865L131.882 12.1972L126.347 7.45583L133.612 6.8734L136.41 0.144043Z"
            fill="#FF3839"
          />
        </svg>
        <p class="text-[#696969] text-lg py-3">
          Expertise technique : Smart Coders Pro possède une expertise technique
          solide. Leur connaissance des dernières tendances et technologies nous
          a permis de rester à la pointe dans notre secteur. Nous les
          recommandons sans réserve."
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.feedback {
  background: black;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
